import { createSlice } from '@reduxjs/toolkit';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { client } from '../../../utils/apolloClient';
import gql from 'graphql-tag';
import jwt_decode from 'jwt-decode';
import { environmentURLs } from '../../../components/common/CaptureEnvironment';
import axios from 'axios';
import { mpDpService } from '../../../services/mp-dp-service/service';

const ELECTRONIC_SIGNING = 'electronic signing';
const ONE_CLICK = 'one click';
const PRIVATE_VISIBILITY = 'Private';

const getUniqueConsentsBy = (attributes = [], consents = [{}]) => {
  const consent = {};
  let result = [];
  consents.forEach((item, index) => {
        let obj = '';
        attributes.forEach(prop => (obj += item[prop]));
        consent[obj] = index;
  });
  const uniqueConsents = Object.keys(consent);
  uniqueConsents.forEach(key => (result = [...result, consents[consent[key]]]));
  return result;
}

const initialState = {
  solutionInfo: {
    overview: {
      solutionLogo:
        'data:image/png;base64,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',
      name: '...',
      publisherName: '...'
    }
  },
  captureDataRights: false,
  planDetails: [],
  selectedPlanId:'',
  apiAndProviders: [],
  apiProviderSelectedByAppPublisher: [],
  apiAndProviderRequiredForTheApp: [],
  isSolutionInfoPending: true,
  isApiProvidersPending: false,
  isAsyncAPIsPending: false,
  asyncAPIs: [],
  isApiProviderSelectedByAppPublisherPending: true,
  preloadAppTermsPending: true,
  preloadAppTermsHeadersPending: true,
  appTermsSignatureCoordinates: '',
  appTermsType: ONE_CLICK,
  preLoadedAppTerms: '',
  customConsentFormSignedS3Url: '',
  getSignedS3UrlPending: false,
  getSignedS3UrlError: false,
  isUserAuthorizedToAccessPrivateApps:false,
  privateSolution:false,
  errorInGettingOrgName:false,
  appTermsSignedS3Url: '',
  monetizationSignedS3Url: '',
  isSolutionInfoSuccess: false,
  constants: {},
  preloadDataRightsPending: true,
  preloadedDataRights: '',
  errorFetchingApiProviders: false,
  errorFetchingAsyncApis: false,
  errorFetchingApiProviderSelectedByAppPublisher: false,
};

export const getSolutionInfo = createAsyncThunk(
  'getSolutionInfo',
  async ({solutionId, token}) => {
    let response = await client.authorizeRequest({
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`
      },
      url: `${environmentURLs.REACT_APP_MP_DP_METADATA_URL}/subscriptions/solutions/${solutionId}`
    });
    response.token = token;
    let {data} = response
    return {data, token};
  }
);

export const getEntityById = createAsyncThunk(
  'getEntityById',
  async ({id, token}) => {
    let response = await client.authorizeRequest({
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`
      },
      url: `${environmentURLs.ORGANIZATION_URL}/organizations/${id}`
    });
    return response;
  }
);

export const getSignedS3Url = createAsyncThunk(
  'getSignedS3Url',
  async ({type, operation, expires, token, fileName}) => {
    let response = await mpDpService.s3.createSignedUrl({type, operation, expires, fileName, token});
    return {
      type,
      response
    };
  }
);

export const getAPIProviders = createAsyncThunk(
  'getAPIProviders',
  async ({ apis, appId, token }) => {
    let response = await axios.post(
      `${environmentURLs.REACT_APP_MP_DP_METADATA_URL}/apis/details`,
      { apiIds: apis, appId },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const apiAndProviders =
      apis &&
      apis.length &&
      apis.map((api) => {
        return {
          apiName: api,
          apiProvider:
            response &&
            response.data &&
            response.data.length &&
            response.data.filter(
              (provider) => provider.id === api || provider.productName === api
            ),
        };
      });
    return apiAndProviders;
  }
);

export const getAsyncAPIs = createAsyncThunk(
  'getAsyncAPIs',
  async ({ asyncApis, appId, token }) => {
    let response = await axios.post(
      `${environmentURLs.REACT_APP_MP_DP_METADATA_URL}/async-apis/details`,
      { asyncApiIds: asyncApis, appId },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response && response.data;
  }
);

export const getDataRightsConsentSigningUrl = createAsyncThunk(
  'getDataRightsConsentSigningUrl',
  async ({ firstName, lastName, email, partyName, cmfNumber }) => {
    let dataRightsConsentSigningUrl = await client.apolloClient.query({
      query: getDataRightsConsentSigningUrlQuery,
      variables: {
        id: this.Id(),
        firstName: '',
        lastName: '',
        email: '',
        organization: partyName,
        cmfNumber: cmfNumber,
        date: this.today(),
        redirectUrl: environmentURLs.SIGNING_REDIRECT_URL,
        emailForBusinessRole: '' //this.props.auth.decodedToken.sub
      }
    });
  }
);

export const getAPIProviderSelectedByAppPublisher = createAsyncThunk(
  'getAPIProviderSelectedByAppPublisher',
  async ({ solutionId, token }) => {
    let response = await axios.get(
      `${environmentURLs.REACT_APP_MP_DP_METADATA_URL}/solutions/${solutionId}/consents?consentType=api_tos`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    return {response};
  }
);

export const preloadDataRights = createAsyncThunk(
  'preloadDataRights',
  async ({type, operation, expires, token, fileName }) => {
    let response = await mpDpService.s3.createSignedUrl({type, operation, expires, fileName, token});
    return {
      type,
      response
    };
  }
);

export const preloadAppTerms = createAsyncThunk(
  'preloadAppTerms',
  async url => {
    let response = await client.authorizeRequest({
      method: 'GET',
      url: url,
      responseType: 'blob'
    });
    return response && response.data;
  }
);

export const preloadAppTermsHeaders = createAsyncThunk(
  'preloadAppTermsHeaders',
  async url => {
    let response = await client.authorizeRequest({
      method: 'HEAD',
      url: url
    });
    if (response.headers.hasOwnProperty('x-amz-meta-signature-coordinates')) {
      return response.headers['x-amz-meta-signature-coordinates'];
    } else {
      return '';
    }
  }
);

export const solutionInfoSlice = createSlice({
  name: 'solutionInfoSlice',
  initialState,
  reducers: {
    savePreloadedTerms: (state, action) => {
      state.preLoadedAppTerms = action.payload;
    },
    saveApiAndProviderRequiredForTheApp: (state, action) => {
      state.apiAndProviderRequiredForTheApp = action.payload;
    },
    resetConsentLink: () => initialState,
    clearSolutionInfo: (state) => {
      state.solutionInfo = {
        overview: {
          solutionLogo:
            "data:image/png;base64,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",
          name: "...",
          publisherName: "..."
        }
      };
      state.captureDataRights = false;
      state.planDetails = [];
      state.apiAndProviders = [];
      state.apiProviderSelectedByAppPublisher = [];
      state.apiAndProviderRequiredForTheApp = [];
      state.isSolutionInfoPending = true;
      state.isApiProvidersPending = true;
      state.isApiProviderSelectedByAppPublisherPending = true;
      state.preloadAppTermsPending = true;
      state.preloadAppTermsHeadersPending = true;
      state.appTermsSignatureCoordinates = "";
      state.appTermsType = ONE_CLICK;
      state.preLoadedAppTerms = "";
      state.preloadDataRightsPending= true;
      state.preloadedDataRights= "";
      state.isSolutionInfoSuccess = false;
    },
    setSelectedPlan:(state,action)=>{
     state.selectedPlanId=action.payload.selectedPlanId
    },
    setConstants: (state, action) => {
      state.constants = action.payload
    }
  },
  extraReducers: {
    [getSolutionInfo.fulfilled]: (state, action) => {
      if (
        action &&
        action.payload &&
        action.payload.data &&
        action.payload.data.solutionInfo &&
        action.payload.data.solutionInfo.data &&
        action.payload.data.solutionInfo.data.length &&
        action.payload.data.solutionInfo.data[0]
      ) {
        const solutionInfo = action.payload.data.solutionInfo.data[0];
        state.solutionInfo = solutionInfo;
        state.isSolutionInfoPending = false;
        state.isSolutionInfoSuccess = true;
        state.captureDataRights =
          solutionInfo.data_rights &&
          solutionInfo.data_rights.captureDataRightsConsent;
        state.planDetails = solutionInfo.plans;
        if(solutionInfo && solutionInfo.solution_visibility && solutionInfo.solution_visibility.solutionVisibilityType && solutionInfo.solution_visibility.solutionVisibilityType === PRIVATE_VISIBILITY && solutionInfo.solution_visibility.privateSolutionUsers){
          state.privateSolution = true;
          if(Array.isArray(solutionInfo.solution_visibility.privateSolutionUsers) && solutionInfo.solution_visibility.privateSolutionUsers.length>0){
            let loggedInUser = jwt_decode(action.payload.token);
            if(loggedInUser && loggedInUser.sub){
              let modifiedUserList = solutionInfo.solution_visibility.privateSolutionUsers.map((item)=>{
                return item.toLowerCase()
              })
              if(modifiedUserList.includes(loggedInUser.sub.toLowerCase())){
                state.isUserAuthorizedToAccessPrivateApps = true;
                state.privateSolution=true;
              }
              else{
                state.isUserAuthorizedToAccessPrivateApps = false;
                state.privateSolution=true;
              }
            }
          }
        }
        else{
          state.privateSolution=false;
        }
      }
    },
    [getSolutionInfo.pending]: state => {
      state.isSolutionInfoPending = true;
      state.isSolutionInfoSuccess = false;
    },
    [getSolutionInfo.rejected]: state => {
      state.solutionInfo = {};
      state.isSolutionInfoPending = false;
      state.isSolutionInfoSuccess = false;
      state.captureDataRights = true;
      state.planDetails = [];
      state.privateSolution=false;
      state.isUserAuthorizedToAccessPrivateApps=false;
    },
    [preloadAppTerms.fulfilled]: (state, action) => {
      state.preLoadedAppTerms = action.payload;
      state.preloadAppTermsPending = false;
    },
    [preloadAppTerms.pending]: state => {
      state.preloadAppTermsPending = true;
    },
    [preloadAppTerms.rejected]: state => {
      state.preloadAppTermsPending = false;
      state.preLoadedAppTerms = '';
    },
    [preloadDataRights.fulfilled]: (state, action) => {
      state.preloadedDataRights = action.payload.response.data.signedRequest;
      state.preloadDataRightsPending = false;
    },
    [preloadDataRights.pending]: state => {
      state.preloadAppTermsPending = true;
    },
    [preloadDataRights.rejected]: state => {
      state.preloadDataRightsPending = false;
      state.preloadDataRights = '';
    },
    [preloadAppTermsHeaders.fulfilled]: (state, action) => {
      state.preloadAppTermsHeadersPending = false;
      state.appTermsSignatureCoordinates = action.payload;
      if (action.payload) {
        state.appTermsType = ELECTRONIC_SIGNING;
      }
    },
    [preloadAppTermsHeaders.pending]: state => {
      state.preloadAppTermsHeadersPending = true;
      state.appTermsSignatureCoordinates = '';
    },
    [preloadAppTermsHeaders.rejected]: state => {
      state.preloadAppTermsHeadersPending = false;
      state.appTermsSignatureCoordinates = '';
    },
    [getAPIProviders.fulfilled]: (state, action) => {
      state.isApiProvidersPending = false;
      state.apiAndProviders = action.payload && action.payload;
      state.errorFetchingApiProviders = false;
    },
    [getAPIProviders.pending]: state => {
      state.isApiProvidersPending = true;
      state.errorFetchingApiProviders = false;
    },
    [getAPIProviders.rejected]: state => {
      state.isApiProvidersPending = false;
      state.errorFetchingApiProviders = true;
    },
    [getAsyncAPIs.fulfilled]: (state, action) => {
      state.isAsyncAPIsPending = false;
      state.asyncAPIs = action.payload && action.payload;
      state.errorFetchingAsyncApis = false;
    },
    [getAsyncAPIs.pending]: state => {
      state.isAsyncAPIsPending = true;
      state.errorFetchingAsyncApis = false;
    },
    [getAsyncAPIs.rejected]: state => {
      state.isAsyncAPIsPending = false;
      state.errorFetchingAsyncApis = true;
    },
    [getAPIProviderSelectedByAppPublisher.fulfilled]: (state, action) => {
      state.isApiProviderSelectedByAppPublisherPending = false;
      let providerObject = action.payload && action.payload.response.data;
      providerObject = Object.values(providerObject).sort((a,b)=>new Date(a.createdDate) - new Date(b.createdDate));
      const consents = getUniqueConsentsBy(['api', 'apiProviderId'], providerObject);
      let apis = [];
      for (var key in consents) {
        apis.push({
          apiName: consents[key].api,
          apiProvider: consents[key]
        });
      }
      state.apiProviderSelectedByAppPublisher = apis;
      state.errorFetchingApiProviderSelectedByAppPublisher= false;
    },
    [getAPIProviderSelectedByAppPublisher.pending]: state => {
      state.isApiProviderSelectedByAppPublisherPending = true;
      state.errorFetchingApiProviderSelectedByAppPublisher= false;
    },
    [getAPIProviderSelectedByAppPublisher.rejected]: state => {
      state.isApiProviderSelectedByAppPublisherPending = false;
      state.errorFetchingApiProviderSelectedByAppPublisher= true;
    },
    [getSignedS3Url.fulfilled]: (state, action) => {
      switch(action.payload && action.payload.type) {
        case 'customConsentForm': {
          state.customConsentFormSignedS3Url = action.payload.response.data.signedRequest;
          break;
        }
        case 'appTerms': {
          state.appTermsSignedS3Url = action.payload.response.data.signedRequest;
          break;
        }
        case 'appTermsHeaders': {
          state.appTermsHeadersSignedS3Url = action.payload.response.data.signedRequest;
          break;
        }
        case 'monetizationAgreement': {
          state.monetizationSignedS3Url = action.payload.response.data.signedRequest;
          break;
        }
      }
      state.getSignedS3UrlPending = false;
    },
    [getSignedS3Url.pending]: state => {
      state.getSignedS3UrlPending = true;
    },
    [getSignedS3Url.rejected]: state => {
      state.getSignedS3UrlPending = false;
      state.getSignedS3UrlError = true;
    },

    [getEntityById.fulfilled]: (state, action = {payload: {data: {}}}) => {
      state.solutionInfo.organizationName = action.payload.data.name;
      state.errorInGettingOrgName = false;
    },
    [getEntityById.pending]: state => {
      state.solutionInfo.organizationName = '';
      state.errorInGettingOrgName = false;
    },
    [getEntityById.rejected]: state => {
      state.solutionInfo.organizationName = '';
      state.errorInGettingOrgName = true;
    },
  }
});

const getDataRightsConsentSigningUrlQuery = gql`
  query(
    $id: String
    $firstName: String
    $lastName: String
    $email: String
    $organization: String
    $cmfNumber: String
    $date: String
    $redirectUrl: String
    $emailForBusinessRole: String
  ) {
    dataRightsConsentSigningUrl(
      id: $id
      firstName: $firstName
      lastName: $lastName
      email: $email
      organization: $organization
      cmfNumber: $cmfNumber
      date: $date
      redirectUrl: $redirectUrl
      emailForBusinessRole: $emailForBusinessRole
    ) {
      signingTransactionId
      links {
        href
        rel
        mediaType
        method
      }
    }
  }
`;

export const {
  savePreloadedTerms,
  saveApiAndProviderRequiredForTheApp,
  clearSolutionInfo,
  setSelectedPlan,
  setConstants,
  resetConsentLink
} = solutionInfoSlice.actions;

export default solutionInfoSlice.reducer;